import { computed, defineAsyncComponent } from "vue";
import { useRoute } from "#app";
import { PAGE_TEMPLATE_TYPES } from "@/templates/_core/templateTypes";
import { useSiteTemplate } from "@/composables/useSiteTemplate";
import { isQiankunPage } from "@/utils/index";

export function useTemplatePage(pageKey, fallbackLayout = "default") {
  const siteTemplate = useSiteTemplate();
  const route = useRoute();

  const pageConfig = computed(() => siteTemplate.resolvePage(pageKey) || {});
  const layoutName = computed(() => {
    // `/sub/**` 已由 app.vue 外层的 qiankun 布局统一渲染 Header/Footer，
    // 页面内部只保留内容布局，避免公共头尾被渲染两次。
    if (isQiankunPage(route.path)) {
      return "empty-layout";
    }
    return pageConfig.value.layout || fallbackLayout;
  });
  const component = computed(() => {
    const config = pageConfig.value;
    if (config.type !== PAGE_TEMPLATE_TYPES.COMPONENT || typeof config.component !== "function") {
      return null;
    }
    return defineAsyncComponent(config.component);
  });
  const isComponentTemplate = computed(() => Boolean(component.value));
  const isLowcodeTemplate = computed(() => pageConfig.value.type === PAGE_TEMPLATE_TYPES.LOWCODE);

  return {
    ...siteTemplate,
    pageConfig,
    layoutName,
    component,
    isComponentTemplate,
    isLowcodeTemplate,
  };
}

export default useTemplatePage;
